// extracted by mini-css-extract-plugin
export default {"activeTab":"PlaylistValidatorTabs_activeTab__YKde2","tabs":"PlaylistValidatorTabs_tabs__BJNIR"};